import { action } from 'mobx';
import { messages } from '@xappex/es-apibuilder/status-error/messages';
import { CancelToken, CancelError } from 'shared/utils/cancelToken';
import { userStore, requestStore } from 'src/stores';

export function tryAction(task, params = [], suppress = false) {
  // It's important to clean store before running task
  // Otherwise race condition happens
  // That is why such obscured way to call task with params = [] is used
  // instead of simply passing here already runnig task
  requestStore.clean();

  return action(task)(...params).then(
    (value) => value,
    async (error) => {
      console.error(error.message);
      console.error(error.stack);

      const status = +error.status || 500;
      if (status === 401) {
        return await userStore.signOut(true);
      }

      if (!(error instanceof CancelError)) {
        const message = messages[error.code] || error.message;
        requestStore.raise(message);
      }
      if (!suppress) { throw error }
    });
}

export async function runAction(task) {
  return await tryAction(task, [], true);
}

export async function runShortAction(task) {
  try {
    requestStore.disableInteraction();
    return await tryAction(task, [], true);
  }
  finally {
    requestStore.enableInteraction();
  }
}

export async function runCancelableAction(task) {
  try {
    const cancelToken = CancelToken.source();

    requestStore.startBlockedOperation({ cancelToken });
    await tryAction(task, [cancelToken], true);
  }
  finally {
    requestStore.stopBlockedOperation();
  }
}